import {ComponentPropsWithoutRef} from 'react';

import {AppImage} from '@/components/Image';
import {formatBadgeImageUrl} from '@/services/loyalty/badgeUtils';
import {twx} from '@/utils/tailwindUtils';

const HERO_BADGE_IMAGE_SIZE = 512;

interface HeroProps extends ComponentPropsWithoutRef<'div'> {
    imageSrc: string;
}

export const Hero = ({children, imageSrc, className}: HeroProps) => {
    const formattedImageSrc = formatBadgeImageUrl(imageSrc, HERO_BADGE_IMAGE_SIZE, HERO_BADGE_IMAGE_SIZE);

    return (
        <div className={twx('flex w-full flex-col items-center justify-center', className)}>
            <div className='h-[205px] w-[205px]'>
                {/*@ts-ignore*/}
                <AppImage
                    className='h-full w-full shrink-0 object-cover'
                    src={formattedImageSrc}
                    decode={false}
                    style={{
                        filter: 'drop-shadow(0px 25px 25px rgba(0, 0, 0, 0.4)) drop-shadow(0px 25px 25px rgba(0, 0, 0, 0.5))',
                        backdropFilter: 'blur(5px)',
                    }}
                />
            </div>
            {children}
        </div>
    );
};
